import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      height: '100%',
      width: '100%',
    },
    card: {
      borderRadius: 0,
      boxShadow: '0 4px 4px 0 rgba(0,0,0,0.3)',
      width: '100%',
    },
    registrationDate: {
      color: '#777',
      fontSize: '0.9em',
      paddingLeft: theme.spacing(2),
    },
    messageDialogDelete: {
      marginTop: theme.spacing(2),
      textAlign: 'center',
    },
    infosDialogDelete: {
      color: theme.palette.primary.main,
      fontWeight: 'bold',
    },
  }),
);

export default useStyles;
